module.exports = __webpack_public_path__ + "img/image-02.5c006da1.jpg";